'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
var PubSub = require('tscom-pubsub');
var template = require('../../templates/thanks.ejs');
var VoteOptionView = require('./voteoption');

module.exports = Backbone.View.extend({
    className: 'view-thanks',
    events: {
        'click .ad a': 'trackEvents'
    },
    contestantsViews: [],
    /**
     * Initialize Thanks View
     */
    initialize: function (options) {
        _.bindAll(this, 'render', 'scrollEvent', 'voteAgain');
        this.optionsList = options.optionsList;
        this.votes = this.optionsList.getTotal();
        this.maxVotes = this.optionsList.maxVotes;
        this.userModel = options.userModel;
        this.votesRemaining = this.maxVotes - this.optionsList.getTotal();
        this.countdownView = options.countdownView;
        this.headerId = 'TelescopeHeader'+_.uniqueId(Math.floor((Math.random())*100));
        this.createShareHeader = options.createShareHeader;
        this.copyCms = options.copyCms;

        this.listenTo(this.copyCms, 'change:language', function() {
            this.contestantsViews.forEach( function(view) {
                view.undelegateEvents();
                view.$el.detach();
            });

            this.render();
            this.renderedToDOM();

            this.contestantsViews.forEach( function(view) {
                view.delegateEvents();
            });
        });
    },
    /**
     * Render Thanks View
     */
    render: function () {
        var model = _.clone(this.copyCms.get('text').views_thanks);
        model.votesRemaining = this.votesRemaining;
        model.headline1 = model.headline1.replace('{{USER}}', '<span class="user">' + ( this.userModel.get('firstName') || this.userModel.get('username') || '' ) + '</span>');
        this.$el.html(template( _.extend({
            faq: this.copyCms.get('text')[ 'views_vote_grid' ][ 'faq' ],
            headerId: this.headerId
        }, model )));
        this.addContestants();
        this.renderCountdown();
        this.addListeners();
        this.createShareHeader( this.$el.find( '.sticky-share' ));
        
        return this;
    },
    /**
     * [renderCountdown description]
     * @return {[type]} [description]
     */
    renderCountdown: function() {
        var $countdownRendered = this.countdownView.render().$el;
        this.countdownRendered = $countdownRendered;
        this.$('.cd-wrapper').html($countdownRendered);
    },
    /**
     * [renderedToDOM description]
     * @return {[type]} [description]
     */
    renderedToDOM: function() {
        this.checkNameSizes();
        // this.setCollectiveHeight();
        $('#'+this.headerId+' .voteAgain').off('click',this.voteAgain);
        $('#'+this.headerId+' .voteAgain').on('click',this.voteAgain);
    },
    /**
     * [addListeners description]
     */
    addListeners: function() {
        $(window).off('scroll',this.scrollEvent);
        $('.page-wrapper .content').off('scroll',this.scrollEvent);
        $('.page-wrapper').off('scroll',this.scrollEvent);

        $(window).on('scroll',this.scrollEvent);
        $('.page-wrapper .content').on('scroll',this.scrollEvent);
        $('.page-wrapper').on('scroll',this.scrollEvent);
    },
    /**
     * [checkNameSizes description]
     * @return {[type]} [description]
     */
    checkNameSizes: function() {
        this.$('.name-container').each(function() {
            var $nameContainer = $( this );
            var $nameText = $nameContainer.find( '.name-text' );

            var font = parseInt( $nameText.css( 'font-size' ) );
            while( $nameContainer.width() + 10 < $nameText.width() && font > 10 )
            {
                font--;
                $nameText.css( 'font-size', font + 'px' );
            }
        });
    },
    /**
     * [setCollectiveHeight description]
     */
    setCollectiveHeight: function(){

        var height = 0;
        this.$('.section').each(function() {
            if($(this).outerHeight() > height){
                height = $(this).outerHeight();
                var item = $('.section');
                item.removeAttr('style');
                item.css('height', $(this).outerHeight() + 'px');
            }
        });
    },
    /**
     * [addContestants description]
     */
    addContestants: function() {
        var elms = [];

        if( this.contestantsViews.length === 0 ) {
            var models = this.optionsList.models;
            models.sort(function(a,b){
                if(a.get('voteCount') < b.get('voteCount')) {
                    return 1;
                } else if(a.get('voteCount') > b.get('voteCount')) {
                    return -1;
                } else {
                    if(a.get('name') > b.get('name')) {
                        return 1;
                    } else if(a.get('name') < b.get('name')) {
                        return -1;
                    } else {
                        return 0;
                    }
                }
            });
            _.each(models, function(value) {
                if(value.get('voteCount') > 0) {
                    var contestant = new VoteOptionView({
                        model: value,
                        type: 'thanks',
                        optionsList: this.optionsList,
                        copyCms: this.copyCms
                    }).render();

                    elms.push( contestant.$el );
                }
            }.bind(this));
        } else {
            this.contestantsViews.forEach( function(view) {
                elms.push( view.$el );
            });
        }

        if(elms.length === 0) {
            this.$('.voted-for').hide();
            return;
        }
        this.$('.contestants').prepend(elms);
        this.$('.contestants').addClass('contestants-'+this.optionsList.models.length);
    },
    /**
     * [voteAgain description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    voteAgain: function(e) {
        e.preventDefault();
        var cta = $(e.currentTarget).text().toLowerCase();
        PubSub.trigger('omniture:action','simpleClick',cta);
        this.trigger('keepVoting',{});
    },
    /**
     * [scrollEvent description]
     * @return {[type]} [description]
     */
    scrollEvent: function() {
        var stickyContainerPos = this.$('.sticky-container').offset().top - $(window).scrollTop() - 24; // the -24 is for padding
        if (stickyContainerPos <= 0) {
            this.$('.sticky-container .outer').addClass('fixed');
            if(this.countdownRendered[0].innerHTML.trim().length > 0) {
                this.$('.cd-wrapper').addClass('fixed');
            }
            this.$('.thanks-headline').addClass('fixed-header');
            if(this.$('.sticky-container .outer').text()) {
                $('#'+this.headerId+' .voteAgain').off('click',this.voteAgain);
                $('#TelescopeAppDWTSModal').html(this.$('.sticky-container .outer'));
                $('.sticky-countdown').html(this.countdownRendered);
                $('#'+this.headerId+' .voteAgain').on('click',this.voteAgain);
                this.headerStuck = true;
            }
        } else {
            if($('#TelescopeAppDWTSModal .outer').text()) {
                $('#'+this.headerId+' .voteAgain').off('click',this.voteAgain);
                this.$('.sticky-container').html($('#TelescopeAppDWTSModal .outer'));
                $('.sticky-countdown').empty();
                this.$('.cd-wrapper').html(this.countdownRendered);
                $('#'+this.headerId+' .voteAgain').on('click',this.voteAgain);
                this.headerStuck = false;
            }
            this.$('.cd-wrapper.fixed').removeClass('fixed');
            this.$('.sticky-container .outer').removeClass('fixed');
            this.$('.thanks-headline').removeClass('fixed-header');
        }
    },
    /**
     * [trackEvents description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    trackEvents: function(e) {
        var cta = $(e.currentTarget).attr('data-track');
        PubSub.trigger('omniture:action','simpleClick',cta);
    },
    /**
     * [remove description]
     * @return {[type]} [description]
     */
    remove: function() {        
        $('.page-wrapper .content').off('scroll');
        $('.page-wrapper').off('scroll');
        $(window).off('scroll');
        $('#'+this.headerId+' .voteAgain').off('click');
        $('#TelescopeAppDWTSModal .outer').html('');
        this.contestantsViews.forEach( function(view) {
            view.remove();
        });
        this.countdownView.remove();
        Backbone.View.prototype.remove.call(this);
    }
});



// WEBPACK FOOTER //
// ./app/scripts/common/views/thanks.js